module.exports = __webpack_public_path__ + "static/media/2_pl.27f3ac10.png";